import {match} from 'ts-pattern';

import {useCallback} from 'react';

import {isArray} from 'ramda-adjunct';

import {businessCaseRoutes} from '@dms/routes';
import {queryParams} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export const useBusinessCasesActionCallback = (): [ActionCallback] => {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = useCallback(
    ({actionKey, rowId, sourceSearchParams}) => {
      if (isArray(rowId)) {
        return;
      }
      const path = composePath(
        `${businessCaseRoutes.overview}?${sourceSearchParams}&${queryParams.REDIRECT_SOURCE}=business-case` as typeof businessCaseRoutes.overview,
        {
          params: {id: rowId},
          isSearchParamsPreserved: false,
        }
      );

      match(actionKey)
        .with('detail', () => navigate(path))
        .with('detail_newTab', () => window.open(path))
        .otherwise(() => {
          // TODO: Create warn utils T20-17310
          console.warn(`Action callback was not specified for action ${actionKey}`);
        });
    },
    [navigate]
  );

  return [actionCallback];
};
